<div class="modalInfoComponent">
    <div class="modal-content">
      <p class="modal-question">{{ modalQuestion }}</p>
      <i class="material-icons icon-warning">warning</i>
      <div class="modal-dialog-alert">
        <p class="modal-excerpt">{{ textDeleteSubject }}</p>
      </div>
      <div class="modal-footer">
        <button
          *ngIf="cancelLabel"
          type="button"
          class="btn btn-danger button-add"
          (click)="closeDialog()"
        >
          {{ cancelLabel }}
        </button>
        <button
          *ngIf="confirmLabel"
          type="button"
          class="btn btn-secondary button-add"
          (click)="onDelete()"
        >
          {{ confirmLabel }}
        </button>
      </div>
    </div>
  </div>
  